import { ReactNode } from "react";
import { useDropzone } from "react-dropzone";
import { UploadIcon } from "lucide-react";
import { useTranslations } from "use-intl";
import { cn } from "@/lib/utils";

export function MessageDropzone({
  onDrop,
  disabled,
  className,
  children,
}: {
  onDrop: (files: File[]) => void;
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}) {
  const t = useTranslations("thread.compose");
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    disabled,
    noClick: true,
    noKeyboard: true,
  });

  return (
    <div
      {...getRootProps()}
      className={cn("relative flex min-h-0 flex-1 flex-col", className)}
    >
      <input {...getInputProps()} />
      {children}
      {isDragActive ? (
        <div className="pointer-events-none absolute inset-1 z-10 flex flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-blue-400 bg-blue-50/90">
          <div className="rounded-full border border-dashed border-blue-300 p-3">
            <UploadIcon className="size-6 text-blue-600" aria-hidden="true" />
          </div>
          <p className="text-sm font-medium text-blue-700">{t("dropTitle")}</p>
          <p className="text-xs text-blue-600">{t("dropHint")}</p>
        </div>
      ) : null}
    </div>
  );
}
